import React, { useState, useEffect } from "react";
import { Alert, Box, Slide } from "@mui/material";

const Alerts = ({ error, type, onClose }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState({ message: "", type: "" });

  useEffect(() => {
    if (error) {
      setAlertInfo({ message: error, type });
      setShowAlert(true);

      const timer = setTimeout(() => {
        setShowAlert(false);
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [error, type, onClose]);

  const handleClose = () => {
    setShowAlert(false);
    onClose();
  };

  return (
    <Slide direction="up" in={showAlert} mountOnEnter unmountOnExit>
      <Box
        className="custom-alert-container"
        sx={{
          position: "fixed",
          bottom: { xs: 16, sm: 24 },
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          px: 2,
          zIndex: 9999,
          pointerEvents: "none",
        }}
      >
        <Alert
          variant="filled"
          severity={alertInfo.type}
          onClose={handleClose}
          className="custom-alert"
          sx={{
            pointerEvents: "auto",
            width: "100%",
            maxWidth: 480,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.22)",
          }}
        >
          {alertInfo.message}
        </Alert>
      </Box>
    </Slide>
  );
};

export default Alerts;
